import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-opposizione-precetto-view',
  templateUrl: './form-opposizione-precetto-view.component.html',
  styleUrls: ['./form-opposizione-precetto-view.component.css']
})
export class FormOpposizionePrecettoViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
